import React, { useEffect, useRef, useState } from "react";

import { useSnackbar } from "notistack";

import {
  api,
  imprimirNotaVenda,
  setVendaCancelada,
  setUuidVendaRascunho,
  getUserId,
} from "../services";
import {
  A_VISTA,
  A_PRAZO,
  TIPO_OFERTA_PRODUTO_LIBERACAO,
  round10,
  toStringItemEnviar,
  IS_IMPRIMIR_VIA_ESTABELECIMENTO,
  IS_IMPRIMIR_COMPROVANTE_TEF_POS_REGISTRO_VENDA,
  STATUS_EMISSAO_NFCE_PENDENTE,
  STATUS_EMISSAO_NFCE_AUTORIZADA,
  STATUS_EMISSAO_NFCE_CONTINGENCIA,
  STATUS_EMISSAO_NFCE_INDEFINIDA,
  STATUS_EMISSAO_NFCE_PROCESSANDO,
  STATUS_EMISSAO_NFCE_REJEITADA,
  STATUS_EMISSAO_NFCE_AUTORIZADA_SEM_XML,
  STATUS_EMISSAO_NFCE_CONTINGENCIA_ENVIADA,
  toleranciaMaximaPermitida
} from "../utils";
import {
  calcularPontosFidelidade,
  getClassificacao,
  getProximoNivel,
} from "../utils/fidelidade";

const idTiposPagamentoRepetidos = [3, 4, 5, 7, 8, 9, 10, 11];

function getComprovantes(parcelas) {
  if (IS_IMPRIMIR_COMPROVANTE_TEF_POS_REGISTRO_VENDA) {
    const comprovantesClientes = [];
    const comprovantesEstabelecimentos = [];

    for (let i = 0; i < parcelas.length; i += 1) {
      const sitef = parcelas[i].sitef;
      if (sitef) {
        const comprovanteCliente = sitef["121"];
        comprovantesClientes.push(comprovanteCliente);

        const comprovanteEstabelecimento = sitef["122"];
        comprovantesEstabelecimentos.push(comprovanteEstabelecimento);
      }
    }

    if (IS_IMPRIMIR_VIA_ESTABELECIMENTO)
      return [...comprovantesClientes, ...comprovantesEstabelecimentos];

    return [...comprovantesClientes];
  }
  return [];
}

// 1 - dinheiro
// 2 - fiado
// 3 - crédito
// 4 - débito
// 5 - pix qrcode
// 6 - Boleto
// 7 - pix - banco do brasil
// 8 - voucher
// 9 - devolucao
// 10 - pix a distancia
// 11 - credito fidelidade

function useParcelasVenda(
  parcelas,
  itens,
  cliente,
  subtotal,
  sessionId,
  updateParcela,
  irParaTelaInit,
  isEmPartes,
  itensExcluidos,
  cpf,
  uuid,
  modoOffline,
  idVenda = -1,
  cnpj,
  tipoNota,
  interfaceSitef,
  CupomFiscal,
  DataFiscal,
  abrirDialogoStatusImpressao,
  fecharDialogoStatusImpressao,
  IdTerminalSitef,
  usar_tef,
  usar_nova_impressao,
  valor_venda_sem_taxa_sistema_fidelidade = 100,
  valor_venda_com_taxa_sistema_fidelidade = 300,
  revenda = false
) {
  const { enqueueSnackbar } = useSnackbar();
  const [podeFecharVenda, setPodeFecharVenda] = useState(true);
  const controle = useRef({ status: true });

  function getTotalAVistaObrigatorio() {
    let total = 0;
    for (let i = 0; i < itens.length; i++) {
      const item = itens[i];
      if (item.tipo_oferta === TIPO_OFERTA_PRODUTO_LIBERACAO) {
        if (!item.is_margem_cartao) {
          total += item.total;
        }
      }
    }
    return total;
  }

  function getTotalAVistaCalculado() {
    let total = 0;
    for (let i = 0; i < parcelas.length; i++) {
      const parcela = parcelas[i];
      if (parcela.tipo_pagamento.id === 1 || parcela.tipo_pagamento.id === 5) {
        total += parcela.valor;
      }
    }
    return total;
  }

  const totalAVistaObrigatorio = getTotalAVistaObrigatorio();
  const totalAVistaCalculado = getTotalAVistaCalculado();

  function parcelaInclusa(id) {
    for (let i = 0; i < idTiposPagamentoRepetidos.length; i += 1) {
      if (id === idTiposPagamentoRepetidos[i]) return true;
    }
    return false;
  }

  function getProcuraPagamentoDinheiro() {
    for (let i = 0; i < parcelas.length; i += 1) {
      if (parcelas[i].tipo_pagamento.id === 1) return true;
    }
    return false;
  }

  function verificaSeDinheiroEUnicoPagamento() {
    if(parcelas.length !== 1) return false
    if(parcelas[0].tipo_pagamento.id === 1) return true
    return false;
  }

  function getProcuraPagamentoNaoPadrao() {
    return false;
  }

  function getPodeEncerrarTransacao(resto) {
    const tolerancia = toleranciaMaximaPermitida(subtotal)
    if (resto >= -1 * tolerancia && resto <= tolerancia) return true;
    return false;
  }

  function getValorRestante() {
    let soma = 0;
    for (let i = 0; i < parcelas.length; i += 1) {
      soma += parcelas[i].valor;
    }
    return subtotal - soma;
  }

  function getTotalParcelas() {
    let soma = 0;
    for (let i = 0; i < parcelas.length; i += 1) {
      soma += parcelas[i].valor;
    }
    return soma;
  }

  function getDescontoUsado() {
    let soma = 0;
    for (let i = 0; i < parcelas.length; i += 1) {
      if (parcelas[i].tipo_pagamento.id === 11) {
        soma += parcelas[i].valor;
      }
    }
    return soma;
  }

  function getDescontosDisponiveisCliente() {
    if (cliente) {
      return parseInt(cliente.score_nao_usado / 100, 10) * 100;
    }
    return 0;
  }

  const resto = getValorRestante();
  const hasDinheiroEUnicoPagamento = verificaSeDinheiroEUnicoPagamento()
  const podeEncerrarTransacao = getPodeEncerrarTransacao(resto);
  const hasPagamentoDinheiro = getProcuraPagamentoDinheiro();
  const hasPagamentoNaoPadrao = getProcuraPagamentoNaoPadrao();
  const totalParcelas = getTotalParcelas();
  const descontoUsadoCliente = getDescontoUsado();
  const descontoDisponivelCliente = getDescontosDisponiveisCliente();

  function hasPixADistancia() {
    return parcelas.some(({ tipo_pagamento }) => tipo_pagamento.id === 10);
  }

  function ehZero(numero, tolerancia = 1e-10) {
    return Math.abs(numero) < tolerancia;
  }

  function getMessagesError() {
    const errors = [];
    if (cliente === null) {
      errors.push({
        message: "Campo cliente não foi preenchido!",
        type: "warning",
      });
    }
    if (parcelas.length <= 0) {
      errors.push({
        message: "É necessário ao menos um registro de parcela!",
        type: "warning",
      });
    }
    if (hasPixADistancia()) {
      if (cliente === null) {
        ///
      } else {
        if (cliente.id === 1) {
          errors.push({
            message:
              "É necessário um cliente com cadastro para o pix à distância!",
            type: "warning",
          });
        }
      }
    }

    const erroDistribuicao = hasDinheiroEUnicoPagamento
      ? !podeEncerrarTransacao
      //: resto < -0.05 || resto > 0.05;
      : !ehZero(resto)
    if (erroDistribuicao) {
      errors.push({
        message:
          "O valor total da venda não foi integralmente distribuído nas parcelas!",
        type: "warning",
      });
    }

    const erroToleravel = hasPagamentoDinheiro ? toleranciaMaximaPermitida(subtotal) : 0;

    if (
      round10(totalAVistaCalculado, -2) <
      round10(totalAVistaObrigatorio - erroToleravel, -2)
    ) {
      errors.push({
        message:
          "O total obrigatório à vista (dinheiro ou pix a distância) não foi respeitado!",
        type: "warning",
      });
    }
    
    return errors;
  }

  useEffect(() => {
    if (getMessagesError().length === 0) {
      enqueueSnackbar("Agora você pode finalizar a Venda!!!", {
        variant: "success",
      });
    }
  }, [parcelas]);

  function montarObjVenda() {
    const listaItens = [];
    const listaItensExcluidos = [];
    const listaParcelas = [];

    for (let i = 0; i < itens.length; i += 1) {
      listaItens.push({
        peso: itens[i].peso,
        unidades: itens[i].unidades,
        preco_venda: itens[i].unitario,
        preco_compra: itens[i].produto.precoCompraMedio,
        produto_id: itens[i].produto.id,
        idIndicadorChange: itens[i].idIndicadorChange,
        unidades_caixa: itens[i].unidadesCaixa,
        preco_venda_caixa: itens[i].unitarioCaixa,
        peso_caixa: itens[i].pesoCaixa,
        unidades_caixa_aparente: itens[i].unidadesCaixaAparente,
        nivel_caixaria: itens[i].nivelCaixaria,
        cgp: itens[i].cgp,
        grupo_oferta_preco_produto_id: itens[i].grupo_oferta_preco_produto_id
          ? itens[i].grupo_oferta_preco_produto_id
          : null,
        tipo_oferta: itens[i].tipo_oferta ? itens[i].tipo_oferta : null,
        is_margem_cartao: itens[i].is_margem_cartao === true ? true : false,
        dadosCgp: itens[i].dadosCgp,
        ...toStringItemEnviar(itens[i]),
      });
    }

    for (let i = 0; i < itensExcluidos.length; i += 1) {
      listaItensExcluidos.push({
        peso: itensExcluidos[i].peso,
        unidades: itensExcluidos[i].unidades,
        preco_venda: itensExcluidos[i].unitario,
        preco_compra: itensExcluidos[i].produto.precoCompraMedio,
        produto_id: itensExcluidos[i].produto.id,
        idIndicadorChange: itensExcluidos[i].idIndicadorChange,
        unidades_caixa: itensExcluidos[i].unidadesCaixa,
        preco_venda_caixa: itensExcluidos[i].unitarioCaixa,
        peso_caixa: itensExcluidos[i].pesoCaixa,
        unidades_caixa_aparente: itensExcluidos[i].unidadesCaixaAparente,
        nivel_caixaria: itensExcluidos[i].nivelCaixaria,
      });
    }

    for (let i = 0; i < parcelas.length; i += 1) {
      const sitef2 = parcelas[i].sitef;
      let sitef = null;
      let n_parcelas = 1;

      if (sitef2) {
        sitef = {};

        if (sitef2["133"]) {
          sitef.nsu_sitef = sitef2["133"];
        }

        if (sitef2["134"]) {
          sitef.nsu_autorizador = sitef2["134"];
        }

        if (sitef2["numero_parcelas"]) {
          n_parcelas = sitef2["numero_parcelas"];
        }

        if (sitef2["122"]) {
          sitef.comprovante_estabelecimento = sitef2["122"];
        }

        if (sitef2["952"]) {
          sitef.numeroAutorizacao = sitef2["952"];
        }

        if (sitef2["951"]) {
          sitef.codigoBandeira = sitef2["951"]; // ou 132
        }

        if (sitef2["950"]) {
          sitef.CNPJAdquirinte = sitef2["950"];
          //sitef.CNPJAdquirinte = '01027058000191'
        } else {
          //sitef.CNPJAdquirinte = '37678452000137'
          sitef.CNPJAdquirinte = '01027058000191'
        }

        sitef.codigoAdquirinte = ''
        sitef.labelBandeira = ''
      }

      listaParcelas.push({
        tipo_pagamento_id: parcelas[i].tipo_pagamento.id,
        data_pagamento: parcelas[i].data_pagamento,
        valor: parcelas[i].valor,
        data_pagamento_real:
          parcelas[i].tipo_pagamento.modalidade === A_VISTA ? new Date() : null,
        valor_recebido:
          parcelas[i].tipo_pagamento.dinheiro_vivo &&
          parcelas[i].tipo_pagamento.modalidade === A_VISTA
            ? parcelas[i].valor_recebido
            : 0,
        idIndicadorChange: parcelas[i].idIndicadorChange,
        autorizador_id: parcelas[i].autorizador_id
          ? parcelas[i].autorizador_id
          : null,
        conta_id: parcelas[i].conta_id ? parcelas[i].conta_id : null,
        credito_devolucao_venda_id: parcelas[i].credito_devolucao_venda_id
          ? parcelas[i].credito_devolucao_venda_id
          : null,
        sitef,
        n_parcelas,
      });
    }

    const tipoNotaFinal = tipoNota
      //tipoNotaOverride !== undefined ? tipoNotaOverride : tipoNota;

    return {
      listaItens,
      listaItensExcluidos,
      listaParcelas,
      data: new Date(),
      cliente_id: cliente.id,
      sessao_id: sessionId,
      devolucao: false,
      is_em_partes: isEmPartes,
      cpf,
      uuid,
      subtotal,
      userId: getUserId(),
      cnpj,
      tipoNota: tipoNotaFinal,
      // revenda só faz sentido na NFe: se o caixa trocar para NFCe na
      // confirmação final, a venda volta a ser de consumidor final
      revenda: tipoNotaFinal === 'nfe' ? !!revenda : false,
      IdTerminalSitef
    };
  }

  async function submitVenda() {
    try {
      const objVenda = montarObjVenda();
      let response = null;
      if (idVenda <= 0) {
        response = await api.post("/vendas_frente_caixa_novo_otimizado", {
          ...objVenda,
        });
      } else {
        response = await api.post(`/edit_vendas_frente_caixa_novo/${idVenda}`, {
          ...objVenda,
        });
      }
      const data = response.data;
      if (data.status) {
        setVendaCancelada(null);
        setUuidVendaRascunho(null);
        return {
          id: data.data.id,
          hora: data.data.hora,
          message: "",
        };
      }
      throw data.message;
    } catch (e) {
      return {
        id: -1,
        message: e ? e.toString() : "error",
      };
    }
  }

  function isTransacaoMultiplosPagamentosTef(parcelas) {
    const TIPOS_TEF = new Set([3, 4, 5]);
    let count = 0;

    for (const p of parcelas) {
      if (TIPOS_TEF.has(p.tipo_pagamento.id)) {
        count++;
        if (count > 1) break;
      }
    }

    const temMultiplosTEF = count > 1;

    return temMultiplosTEF;
  }

  function isTransacaoTef(parcelas) {
    const TIPOS_TEF = new Set([3, 4, 5]);
    let count = 0;

    for (const p of parcelas) {
      if (TIPOS_TEF.has(p.tipo_pagamento.id)) {
        count++;
        break;
      }
    }

    const temMultiplosTEF = count > 0;

    return temMultiplosTEF;
  }

function pause(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

  async function handleFinalizarVenda() {
    const errors = getMessagesError();
    if (errors.length <= 0 && controle.current.status) {
      controle.current.status = false;
      setPodeFecharVenda(false);
      abrirDialogoStatusImpressao('Aguarde...', 'Registrando Venda...')
      const responseVenda = await submitVenda();
      if (responseVenda.id > 0) {
        // a consulta de status de emissão e a impressão automática só existem
        // para NFCe; a NFe não passa por esse fluxo
        if (tipoNota !== 'nfe') {
          let tentativas = 0
          let MAXTENTATIVAS = 30

          abrirDialogoStatusImpressao('Aguarde...', 'Emitindo Nota Fiscal...')

          let status_emissao_nfce = null

          let quantidadeErros = 0

          for(let i = 0; i < MAXTENTATIVAS && !status_emissao_nfce && quantidadeErros < 3; i++) {
            try {
              const response = await api.get(`/get-status-emissao-nfce/${responseVenda.id}`)
              const { status, message, data } = response.data

              if(status) {
                switch (data.status) {
                  case STATUS_EMISSAO_NFCE_AUTORIZADA: {
                    status_emissao_nfce = STATUS_EMISSAO_NFCE_AUTORIZADA
                    break;
                  }

                  case STATUS_EMISSAO_NFCE_REJEITADA: {
                    status_emissao_nfce = STATUS_EMISSAO_NFCE_REJEITADA
                    break;
                  }

                  case STATUS_EMISSAO_NFCE_AUTORIZADA_SEM_XML: {
                    status_emissao_nfce = STATUS_EMISSAO_NFCE_AUTORIZADA_SEM_XML
                    break;
                  }

                  case STATUS_EMISSAO_NFCE_CONTINGENCIA_ENVIADA: {
                    status_emissao_nfce = STATUS_EMISSAO_NFCE_CONTINGENCIA_ENVIADA
                    break;
                  }
                  default:
                    break;
                }
              }
            } catch(e) {
              quantidadeErros++
            }

            await pause(2000);
          }

          try {
            if(status_emissao_nfce === STATUS_EMISSAO_NFCE_AUTORIZADA || status_emissao_nfce === STATUS_EMISSAO_NFCE_CONTINGENCIA_ENVIADA) {
              const comprovantes = getComprovantes(parcelas);

              abrirDialogoStatusImpressao('Aguarde...', 'Imprimindo Nfce e comprovantes TEF')

              const codigo = await imprimirNotaVenda(responseVenda.id, modoOffline, usar_nova_impressao, comprovantes);
            /*  if (codigo < 0) {
                enqueueSnackbar(
                  'Erro ao imprimir a nota!',
                  {
                    variant: 'error',
                  },
                );
              } */
            } else {
              const comprovantes = getComprovantes(parcelas);

              abrirDialogoStatusImpressao('Aguarde...', 'Imprimindo Nfce e comprovantes TEF')

              const codigo = await imprimirNotaVenda(responseVenda.id, modoOffline, usar_nova_impressao, comprovantes);
              /* if (codigo < 0) {
                enqueueSnackbar(
                  'Erro ao imprimir a nota!',
                  {
                    variant: 'error',
                  },
                );
              } */
              /* enqueueSnackbar(
                  'Erro ao imprimir a nota lllllllllllllllllllllllllllllll!',
                  {
                    variant: 'error',
                  },
                ); */

            }
          } catch(e) {
            enqueueSnackbar(
              'Erro ao imprimir a nota!',
              {
                variant: 'error',
              },
            );
          }
        }

        //if(isTransacaoMultiplosPagamentosTef(parcelas) && usar_tef) {
        if (isTransacaoTef(parcelas) && usar_tef) {
          const dados = await interfaceSitef.finishTransaction({
            confirma: 1,
            cupomFiscal: CupomFiscal,
            dataFiscal: DataFiscal,
            horaFiscal: responseVenda.hora,
          });

          if (dados.status) {
          } else {
          }
        }

        // ── Pontos de fidelidade ──────────────────────────────────────────
    /*     if (cliente && cliente.is_fidelidade) {
          const pontosGanhos = calcularPontosFidelidade({
            itens,
            parcelas,
            valorSemTaxa: valor_venda_sem_taxa_sistema_fidelidade,
            valorComTaxa: valor_venda_com_taxa_sistema_fidelidade,
            TIPO_LIBERACAO: TIPO_OFERTA_PRODUTO_LIBERACAO,
          });

          if (pontosGanhos > 0) {
            const novoScoreTotal = (cliente.score_total || 0) + pontosGanhos;
            const classificacao = getClassificacao(novoScoreTotal);
            const proximoNivel = getProximoNivel(novoScoreTotal);

            const conteudoPontos = (
              <div style={{ textAlign: 'center', padding: '16px 8px' }}>
                <p style={{ fontSize: '25px', margin: '0 0 12px' }}>
                  Parabéns <strong>{cliente.nome}</strong>, você acaba de GANHAR:
                </p>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    justifyContent: 'center',
                    gap: '10px',
                    margin: '20px 0',
                  }}
                >
                  <span
                    style={{
                      fontSize: '96px',
                      fontWeight: 'bold',
                      lineHeight: 1,
                      color: '#1a237e',
                    }}
                  >
                    {pontosGanhos}
                  </span>
                  <span
                    style={{
                      fontSize: '28px',
                      fontWeight: 'bold',
                      color: '#283593',
                      paddingBottom: '14px',
                    }}
                  >
                    PONTO{pontosGanhos !== 1 ? 'S' : ''}
                  </span>
                </div>
                <p style={{ fontSize: '25px', margin: '8px 0' }}>
                  Sua pontuação acumulada é de:{' '}
                  <strong>{novoScoreTotal}</strong> pontos.
                </p>
              </div>
            );

            abrirDialogoStatusImpressao(
              '🎉 Venda Concluída!',
              '',
              conteudoPontos,
              () => {
                fecharDialogoStatusImpressao();
                irParaTelaInit();
              },
            );
            return; // aguarda o clique do usuário em "Fechar"
          }
        } */
        // ─────────────────────────────────────────────────────────────────

        fecharDialogoStatusImpressao()

        irParaTelaInit();
      } else {
        controle.current.status = true;
        setPodeFecharVenda(true);
        enqueueSnackbar(responseVenda.message, {
          variant: "error",
        });
        fecharDialogoStatusImpressao()
      }
    } else {
      for (let i = 0; i < errors.length; i += 1) {
        enqueueSnackbar(errors[i].message, {
          variant: errors[i].type,
        });
      }
    }
  }

  async function handleFinalizarVenda2() {
    const errors = getMessagesError();
    if (errors.length <= 0 && controle.current.status) {
      controle.current.status = false;
      setPodeFecharVenda(false);
      abrirDialogoStatusImpressao('Aguarde...', 'Registrando Venda...')
      const responseVenda = await submitVenda();
      abrirDialogoStatusImpressao('Aguarde...', 'Emitindo Nota Fiscal...')
      if (responseVenda.id > 0) {
        /* const codigo = await imprimirNotaVenda(responseVenda.id, modoOffline);
        if (codigo < 0) {
          enqueueSnackbar(
            'Erro ao imprimir a nota!',
            {
              variant: 'error',
            },
          );
        } */

        /* const comprovantes = getComprovantes(parcelas) */

        const comprovantes = getComprovantes(parcelas);

        abrirDialogoStatusImpressao('Aguarde...', 'Imprimindo Nfce e comprovantes TEF')

        const codigo = await imprimirNotaVenda(responseVenda.id, modoOffline, usar_nova_impressao, comprovantes);
        if (codigo < 0) {
          enqueueSnackbar(
            'Erro ao imprimir a nota!',
            {
              variant: 'error',
            },
          );
        }

        if(isTransacaoMultiplosPagamentosTef(parcelas) && usar_tef) {
          const dados = await interfaceSitef.finishTransaction({
            confirma: 1,
            cupomFiscal: CupomFiscal,
            dataFiscal: DataFiscal,
            horaFiscal: responseVenda.hora,
          });

          if (dados.status) {
          } else {
          }
        }

        fecharDialogoStatusImpressao()

        irParaTelaInit();
      } else {
        controle.current.status = true;
        setPodeFecharVenda(true);
        enqueueSnackbar(responseVenda.message, {
          variant: "error",
        });
        fecharDialogoStatusImpressao()
      }
    } else {
      for (let i = 0; i < errors.length; i += 1) {
        enqueueSnackbar(errors[i].message, {
          variant: errors[i].type,
        });
      }
    }
  }

  function handleNewItem(
    {
      valor,
      tipo_pagamento,
      data_pagamento,
      troco,
      valor_recebido,
      conta_id,
      conta,
      sitef,
    },
    autorizador_id
  ) {
    if (
      tipo_pagamento.modalidade === A_VISTA ||
      (tipo_pagamento.modalidade === A_PRAZO &&
        cliente.nome &&
        cliente.cpf &&
        cliente.telefone &&
        tipo_pagamento.boleto_gerencianet) ||
      (tipo_pagamento.modalidade === A_PRAZO &&
        !tipo_pagamento.boleto_gerencianet)
    ) {
      updateParcela({
        data_pagamento,
        tipo_pagamento,
        valor,
        uidd: `${tipo_pagamento.nome}${parcelas.length}`,
        troco,
        valor_recebido,
        idIndicadorChange: -1,
        autorizador_id,
        conta_id,
        conta,
        sitef,
      });
    } else {
      enqueueSnackbar(
        "Este cliente não possui dados suficientes para o cadastro de boletos na plataforma Gerencianet!",
        {
          variant: "warning",
        }
      );
    }
  }

  function getPodeUsarParcela(id) {
    const idInclusoRepetidos = parcelaInclusa(id);

    if (idInclusoRepetidos) {
      return {
        status: true,
        message: "",
      };
    }
    if (id === 1) {
      if (hasPagamentoDinheiro) {
        return {
          status: false,
          message: "Já existem uma parcela em dinheiro registrada!",
        };
      }
      return {
        status: true,
        message: "",
      };
    }
    if (hasPagamentoNaoPadrao) {
      return {
        status: false,
        message: "Já existem uma parcela á prazo registrada!",
      };
    }
    return {
      status: true,
      message: "",
    };
  }

  return {
    resto,
    podeEncerrarTransacao,
    hasPagamentoDinheiro,
    totalParcelas,
    handleFinalizarVenda,
    handleNewItem,
    enqueueSnackbar,
    getPodeUsarParcela,
    hasPagamentoNaoPadrao,
    podeFecharVenda,
    descontoUsadoCliente,
    descontoDisponivelCliente,
    totalAVistaObrigatorio,
    totalAVistaCalculado,
    ehZero,
    hasDinheiroEUnicoPagamento
  };
}

export default useParcelasVenda;
